import type {
  EditableWorkPolicyApplicationDetail,
  WorkPolicyApplicationApi,
  WorkPolicyApplicationRequest,
  WorkPolicyApplicationSuccessEnvelope
} from "../../../../api/work-policy-application-api.types";

interface ExecuteCommandInput {
  api: WorkPolicyApplicationApi;
  mode: "draft" | "submit";
  request: WorkPolicyApplicationRequest;
  approvalRequestIdx?: number;
}

interface ReconcileAndResumeInput {
  api: WorkPolicyApplicationApi;
  mode: "draft" | "submit";
  request: WorkPolicyApplicationRequest;
  approvalRequestIdx: number;
}

export function executeWorkPolicyApplicationCommand({
  api,
  mode,
  request,
  approvalRequestIdx
}: ExecuteCommandInput): Promise<
  WorkPolicyApplicationSuccessEnvelope<EditableWorkPolicyApplicationDetail>
> {
  if (mode === "draft") {
    return approvalRequestIdx
      ? api.updateDraft(approvalRequestIdx, request)
      : api.createDraft(request);
  }
  return approvalRequestIdx
    ? api.submitDraft(approvalRequestIdx, request)
    : api.createSubmission(request);
}

export async function reconcileAndResumeWorkPolicyApplication({
  api,
  mode,
  request,
  approvalRequestIdx
}: ReconcileAndResumeInput): Promise<
  WorkPolicyApplicationSuccessEnvelope<EditableWorkPolicyApplicationDetail>
> {
  await api.detail(approvalRequestIdx);
  return mode === "draft"
    ? api.updateDraft(approvalRequestIdx, request)
    : api.resume(approvalRequestIdx, request);
}
